<template>
    <el-table
        :data="items"
    >
        <el-table-column prop="name" label="Name"></el-table-column>
        <el-table-column prop="value" label="Value">
            <template v-slot="{row:{value, name}}">
                <table-input :value="value" :name="name" @input="onInput"></table-input>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
  import TableInput from './table-input';

  export default {
    components: {
      TableInput,
    },

    props: {
      value: null,
      schema: null,
    },

    computed: {
      /**
       * @return {Array}
       */
      items() {
        return _.map(this.schema, item => {
          return _.assign({}, item, {value: _.get(this.value, item.name, '')});
        });
      },
    },

    methods: {
      /**
       * @param {string} name
       * @param {*} value
       */
      onInput({name, value}) {
        const styles = value
          ? _.assign({}, this.value, {[name]: value})
          : _.omit(this.value, name);

        this.$emit('input', styles);
      }
    },
  }
</script>

